import React, {useCallback, useState, useEffect} from "react";
import {isMobile} from 'mobile-device-detect';
import {useStoreActions} from "easy-peasy"; // useStoreState
import {LandscapeModal} from '../components';
import anime from 'animejs';

// import {getContentForLtm, getBodyCopyForLtm} from '../utils/contentful';
// import {createResults} from '../utils/results';
// import {loadRemainingAnimations} from '../utils/animation';

const CTA = props => {
    const goto                = useStoreActions(actions => actions.path.goto);
    const setCurrentAnimation = useStoreActions(actions => actions.animation.setCurrent);

    // const setAnswers        = useStoreActions(actions => actions.answers.update);
    // const ltmContent        = useStoreState(state => state.content.all);
    // const answers           = useStoreState(state => state.answers.current);
    // const updateResults     = useStoreActions(actions => actions.results.update);
    // const updateResultsCopy = useStoreActions(actions => actions.resultsCopy.update);

    const [isLandscape, setIsLandscape] = useState(Math.abs(window.orientation) === 90);

    // eslint-disable-next-line max-statements
    const screenOrientation = e => {
        setIsLandscape(Math.abs(window.orientation) === 90);
        if (Math.abs(window.orientation) === 90) {
            window.scrollTo(0, 0);
            document.body.style.minHeight                          = `100%`;
            document.documentElement.style.minHeight               = `100%`;
            document.querySelector(`#root`).style.minHeight        = `100%`;
            document.querySelector(`.App`).style.minHeight         = `100%`;
            document.querySelector(`.lottie-anim`).style.minHeight = `100%`;
            if (document.querySelector(`.legal-container`)) {
                document.querySelector(`.legal-container`).style.display = `none`;
            }
            if (document.querySelector(`.results-legal-container`)) {
                document.querySelector(`.results-container`).style.display  = `none`;
                document.querySelector(`.closing-section`).style.display    = `none`;
                document.querySelector(`.tan-blob-container`).style.display = `none`;
            }
            setTimeout(() => {
                document.body.scrollTop = 0;
            }, 500);
        } else {
            document.body.style.minHeight                          = ``;
            document.documentElement.style.minHeight               = ``;
            document.querySelector(`#root`).style.minHeight        = ``;
            document.querySelector(`.App`).style.minHeight         = ``;
            document.querySelector(`.lottie-anim`).style.minHeight = ``;
            if (document.querySelector(`.legal-container`)) {
                document.querySelector(`.legal-container`).style.display = ``;
            }
            if (document.querySelector(`.results-legal-container`)) {
                document.querySelector(`.results-container`).style.display  = ``;
                document.querySelector(`.closing-section`).style.display    = ``;
                document.querySelector(`.tan-blob-container`).style.display = ``;
            }
            setTimeout(() => {
                document.body.scrollTop = 0;
            }, 500);
        }
    };

    const touchmove = e => {
        if (Math.abs(window.orientation) === 90) {
            e.preventDefault();

            return false;
        } else {
            return true;
        }
    };

    window.addEventListener(`orientationchange`, screenOrientation);
    window.addEventListener(`touchmove`, touchmove, {passive: false});

    useEffect(() => {
        anime({
            targets  : `.cta-holder`,
            opacity  : 1,
            easing   : `linear`,
            duration : 1300,
            delay    : 4000
        });
    });

    // const skipToResults = () => {
    //     const LTM          = `family`;
    //     const FEELING      = `generic`;
    //     const PREPAREDNESS = `just_starting`;
    //     const PRIORITIES   = [];
    //     loadRemainingAnimations(LTM).then(() => {
    //         console.log(ltmContent);
    //         let animationData = {
    //             path     : `/animations/children/childbirth-q4-results.json`,
    //             autoplay : true,
    //             loop     : false
    //         };
    //         setCurrentAnimation(animationData);
    //         getContentForLtm(answers[0]).then(content => {
    //             setAnswers([LTM, FEELING, PREPAREDNESS, PRIORITIES]);
    //             updateResults(createResults([LTM, FEELING, PREPAREDNESS, PRIORITIES], content));
    //             getBodyCopyForLtm(LTM).then(copy => updateResultsCopy(copy));
    //             goto(`/results`);
    //         }).catch(e => {
    //             console.warn(e);
    //         });
    //     });
    // };

    // eslint-disable-next-line id-length
    const onEnterOrSpaceDownHandler = useCallback(event => {
        if (event.keyCode === 13 || event.keyCode === 32) {
            window.location.href = `https://www.guardianlife.com`;
        }
    }, []);

    const onClick = useCallback(() => {
        window.dataLayer.push(`GetStarted`);

        setCurrentAnimation({
            path     : `/animations/intro/intro-q1.json`,
            autoplay : true,
            loop     : {
                path : `/animations/intro/intro-q1-loop.json`
            }
        });

        anime({
            opacity  : 0,
            targets  : `.cta-holder`,
            duration : 600,
            complete : () => {
                goto(`/q1`);
            }
        });
    }, [goto, setCurrentAnimation]);

    return (
        <section className="intro" >
            <LandscapeModal display={isLandscape}/>
            <a onKeyDown={onEnterOrSpaceDownHandler} className="guardian-link" href="https://www.guardianlife.com">
                <img src={`/images/guardian-logo.png`} alt={`Link to Guardian Life Website`} />
            </a>
            <section className="cta-holder">
                <h2>The big moments in life come with a lot of questions.</h2>
                {!isMobile && <><p>What are my options moving forward? Where can I find relevant information? Am I even doing this right? </p>
                    <p>The good thing is, you're not alone. Let us sift through the endless sea of information to find resources just for you.</p></>}
                {isMobile && <p>Let us sift through the endless sea of information to find resources just for you.</p>}
                <button onClick={onClick} aria-controls="App">Let's get started</button>
            </section>
        </section>
    );
};

export default CTA;
